import { Attr, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactMailingListsContact from "./ContactMailingListsContact";
import type ContentVersion from "./ContentVersion";
import type MediaReleaseRecipient from "./MediaReleaseRecipient";

@Model()
class ContactMailingList extends ApplicationRecord {
  static jsonapiType = "contact_mailing_lists";

  @HasMany() contactMailingListsContacts: ContactMailingListsContact[];

  @Attr() createdAt: string;

  @HasMany() mediaReleaseRecipients: MediaReleaseRecipient[];

  @Attr() name: string;

  @Attr() publishedAt: string;

  @Attr() recipientsCount: number;

  @Attr() updatedAt: string;

  @HasMany() versions: ContentVersion[];
}

export default ContactMailingList;
